import PageFilter from '@/shared/filters/pageFilter';

export default class AdvancedFilter {
    constructor() {
        this.action = '';
        this.search = '';
        this.pageFilter = new PageFilter();
        this.area = true;
        this.region = 0;
    }

    asQuery() {
        let filter = {};
        if (this.search && this.search.length > 0) {
            filter.search = this.search;
        }
        if (this.action && this.action > 0) {
            filter.action = this.action;
        }

        filter.pageFilter = this.pageFilter.asQuery();
        filter.area = this.area;
        filter.region = this.region;

        return filter;
    }
}